import { debounceTime, finalize, map } from 'rxjs/operators';
import { ApiDataSource } from '../api.data-source';
import { CustomerExperienceAssignCategoryService } from './customer-experience-assign-category.service';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CustomerExperienceCategoriesService } from '../customer-experience-categories/customer-experience-categories.service';

export class CustomerExperienceAssignCategoryDataSource extends ApiDataSource<any> {

    public isOpenedNewTab = false;

    public $status = of([
        { key: true, value: this.translate.instant('GENERAL.ACTIVE') },
        { key: false, value: this.translate.instant('GENERAL.PASSIVE') }
    ]);


    public $users = this.assignCategoryService.listCreatedUsers({ filter: {} }).pipe(
        map(response => response.data),
        map(users => users.map(item => {
            return {
                key: item.userId,
                value: item.displayName
            };
        }))
    );

    public $categories = this.categoryService.search({
        orderBy: 'orderBy',
        orderType: 'ASC',
        page: 1,
        pageSize: 1000,
        filter: {}
    }).pipe(
        map(response => response.data.results),
        map(categories => categories.map(category => {
            return {
                key: category.cxCategoryId,
                value: category.name
            };
        }))
    );

    constructor(
        private assignCategoryService: CustomerExperienceAssignCategoryService,
        private categoryService: CustomerExperienceCategoriesService,
        private translate: TranslateService,
        protected initialFilter?: any,
    ) {
        super(initialFilter);
    }


    private filterReq: any;

    getFilter() {
        return this.filterReq;
    }

    load(): void {
        if (!this.isOpenedNewTab) {
            // Init filter with data source's default filter
            const filterValue: any = { ...this.initialFilter, ...this.filter };

            // If filter keyword exists, filter data
            if (this.keyword) {
                filterValue.searchText = this.keyword;
            }

            // Update loading state
            this.loadingSubject.next(true);

            // Create request parameters
            const request = this.getRequest();
            if (!request.orderType) {
                request.orderType = 'ASC';
                request.orderBy = 'orderBy';
            }

            if (this.paginator?.pageSize) {
                request.pageSize = this.paginator.pageSize;
            }

            // Add filters to request
            request.filter = filterValue;

            this.filterReq = { ...request };
            // Fetch data
            this.assignCategoryService
                .search(request)
                .pipe(
                    debounceTime(400),
                    finalize(() => this.loadingSubject.next(false))
                ).subscribe(response => {
                    // Update count and data subjects
                    this.dataSubject.next(response.data.results);
                    this.dataCountSubject.next(response.data.rowCount);

                    // Update data source's empty based row count
                    this.empty = response.data.rowCount === 0;
                });
        }

        return this.loadingSubject.next(false);
    }
}
